import { render } from "./Pricing.vue?vue&type=template&id=5838fe65&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"

import "./Pricing.vue?vue&type=style&index=0&id=5838fe65&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5838fe65"]])

export default __exports__